// Motion constants — matched to vaul (github.com/emilkowalski/vaul) so the
// slide feel is identical: transform 0.5s cubic-bezier(0.32,0.72,0,1).
export const BS_DURATION_MS = 500;
export const BS_EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';
export const BS_TRANSITION_TRANSFORM = `transform ${BS_DURATION_MS}ms ${BS_EASE}`;
export const BS_TRANSITION_OPACITY = `opacity ${BS_DURATION_MS}ms ${BS_EASE}`;

// Dismiss thresholds (vaul: CLOSE_THRESHOLD 0.25, velocity in px/ms).
export const BS_CLOSE_THRESHOLD = 0.25; // fraction of panel height dragged
export const BS_VELOCITY_THRESHOLD = 0.4; // px/ms downward
export const BS_VELOCITY_WINDOW_MS = 100;
